import { render, staticRenderFns } from "./ProductWeightsMeasures.vue?vue&type=template&id=35ad2c66"
import script from "./ProductWeightsMeasures.vue?vue&type=script&lang=js"
export * from "./ProductWeightsMeasures.vue?vue&type=script&lang=js"
import style0 from "./ProductWeightsMeasures.vue?vue&type=style&index=0&id=35ad2c66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports